import React from 'react';
import { Navigation } from '../components/Navigation';
import { SaleHero } from '../components/SaleHero';
import { SaleWhyUs } from '../components/SaleWhyUs';
import { SaleServices } from '../components/SaleServices';
import { SaleFAQ } from '../components/SaleFAQ';
import { Testimonials } from '../components/Testimonials';
import { Consultation } from '../components/Consultation';
import { Footer } from '../components/Footer';
import { CookieBanner } from '../components/CookieBanner';
import { FloatingContact } from '../components/FloatingContact';
export function SalePage() {
  return <div className="min-h-screen w-full" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-821">
      <Navigation data-id="element-822" />

      <main className="pt-[72px]" data-id="element-823">
        {' '}
        {/* Add padding top to account for fixed navigation */}
        <SaleHero data-id="element-824" />
        <Consultation data-id="element-825" />
        <SaleWhyUs data-id="element-826" />
        <SaleServices data-id="element-827" />
        <SaleFAQ data-id="element-828" />
        <Testimonials data-id="element-829" />
        <Consultation data-id="element-830" />
      </main>

      <Footer data-id="element-831" />
      <CookieBanner data-id="element-832" />
      <FloatingContact data-id="element-833" />
    </div>;
}